import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';

type ValidHeadlineLevels = 1 | 2 | 3 | 4 | 5 | 6;

export interface Props extends Children, ClassName, Layer, Gap, TestId {
  /** The headline's semantic level (h1-h6) */
  level: ValidHeadlineLevels;

  /** The visual headline level */
  as?: ValidHeadlineLevels;
}

const styles = new Map([
  [1, 'text-5xl'],
  [2, 'text-4xl'],
  [3, 'text-3xl'],
  [4, 'text-2xl'],
  [5, 'text-xl'],
  [6, 'text-lg'],
]);

/** A component to render various kinds of headlines with */
const Headline = ({
  children,
  className = '',
  level,
  as,
  gap = 'xl',
  layer = 0,
  testId,
}: Props): React.ReactElement =>
  React.createElement(
    `h${level}`,
    {
      className: `${styles.get(as || level)} gap--${gap} layer--${layer} ${className}`,
      'data-testid': testId,
    },
    children
  );

export default Headline;
